import { motion } from 'motion/react';

import { useI18n } from '../../i18n';

export default function AboutSection() {
  const { t } = useI18n();

  return (
    <motion.section
      id="about"
      className="bg-white px-4 py-12 sm:px-6 sm:py-16 md:px-8 md:py-20 lg:px-32"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, margin: '-100px' }}
    >
      <div className="mx-auto max-w-6xl">
        <motion.div
          className="mb-12 text-center"
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          <motion.h2
            className="mb-6 text-2xl font-bold text-gray-900 sm:text-3xl md:text-4xl"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            {t.about.title}
          </motion.h2>
          <motion.p
            className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg md:text-xl"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            viewport={{ once: true }}
          >
            {t.about.description}
          </motion.p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <motion.div
            className="rounded-2xl bg-[#00a63e] p-6 text-white sm:p-8"
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.8, ease: 'easeOut' }}
            viewport={{ once: true }}
            whileHover={{
              scale: 1.02,
              boxShadow: '0 20px 40px rgba(0, 166, 62, 0.3)',
            }}
          >
            <div className="flex items-center gap-2">
              <motion.div
                className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white/20"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ delay: 0.4, duration: 0.3, type: 'spring' }}
                viewport={{ once: true }}
              >
                <img
                  src="/images/icons/lightbulb.svg"
                  alt={t.about.vision.alt}
                  className="h-6 w-6 brightness-0 invert"
                />
              </motion.div>
              <motion.h3
                className="mb-3 text-xl font-bold sm:text-2xl"
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.6 }}
                viewport={{ once: true }}
              >
                {t.about.vision.title}
              </motion.h3>
            </div>
            <motion.p
              className="text-base leading-relaxed sm:text-lg"
              initial={{ y: 15, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              viewport={{ once: true }}
            >
              {t.about.vision.description}
            </motion.p>
          </motion.div>

          <motion.div
            className="rounded-2xl bg-blue-900 p-6 text-white sm:p-8"
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8, ease: 'easeOut' }}
            viewport={{ once: true }}
            whileHover={{
              scale: 1.02,
              boxShadow: '0 20px 40px rgba(30, 58, 138, 0.3)',
            }}
          >
            <div className="flex items-center gap-2">
              <motion.div
                className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white/20"
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ delay: 0.6, duration: 0.3, type: 'spring' }}
                viewport={{ once: true }}
              >
                <img
                  src="/images/icons/target.svg"
                  alt={t.about.mission.alt}
                  className="h-6 w-6 brightness-0 invert"
                />
              </motion.div>
              <motion.h3
                className="mb-3 text-xl font-bold sm:text-2xl"
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.7, duration: 0.6 }}
                viewport={{ once: true }}
              >
                {t.about.mission.title}
              </motion.h3>
            </div>
            <motion.p
              className="text-base leading-relaxed sm:text-lg"
              initial={{ y: 15, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.6 }}
              viewport={{ once: true }}
            >
              {t.about.mission.description}
            </motion.p>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
}
